import { useGlobalState } from '@/hooks';
import { getPmtLangHref } from '@/utils';
import Link from 'next/link';
import type { FC } from 'react';
import { CloseButton, CloseIcon, Logo, MobilePopupHeaderWrapper } from './MobilePopupHeader.styles';

interface IMobilePopupHeader {
  onClose?: () => void;
}

export const MobilePopupHeader: FC<IMobilePopupHeader> = ({ onClose }) => {
  const { pmtCurrentLanguageCode } = useGlobalState();

  return (
    <MobilePopupHeaderWrapper>
      <Link href={getPmtLangHref(pmtCurrentLanguageCode) ?? '#'} passHref onClick={onClose}>
        <Logo />
      </Link>
      <CloseButton>
        <CloseIcon aria-label='Close onboarding popup' onClick={onClose} />
      </CloseButton>
    </MobilePopupHeaderWrapper>
  );
};
